exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._2JdNWDu7bXYHISUA3MlKzp>div{padding:4px 0 0 4px}html[dir=rtl] ._2JdNWDu7bXYHISUA3MlKzp>div{padding:4px 4px 0 0}", ""]);
// Exports
exports.locals = {
	"contextualFormatBar": "_2JdNWDu7bXYHISUA3MlKzp"
};